module.exports = __webpack_public_path__ + "static/CSIRUKPRJ-594-Performance-Test-Temtum-Crypto-Currency-Network-v1.0-4a2700fabf451f775dd45afd77c1a07d.pdf";